import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CultureService } from 'src/app/modules/core/services/culture.service';
import { DocumentReader } from 'src/app/modules/core/store/models';

@Component({
    selector: 'app-geometry-cell',
    templateUrl: './geometry-cell.component.html',
    styleUrls: ['./geometry-cell.component.scss'],
    standalone: false
})
export class GeometryCellComponent implements OnInit {
  value: any;

  constructor(private translate: TranslateService, private cultureService: CultureService) {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;
    const field = params.schemaField;
    const reader = new DocumentReader(document);

    this.value = !!params.data ? reader.getFormattedFieldValue(field.systemName, field, this.cultureService) : params.value;
  }
}
